import styled from "styled-components";

export const CreditSummaryContainer = styled.div`
  align-content: flex-start;
  justify-content: flex-start;
`;
